import React from 'react';
import { View, Text } from 'react-native';

export default ({ moment, C, historyHeight, hourLength, scale, font }) => {
  return (
    <View style={{ width: hourLength }}>
      <Text
        style={[
          font['Time 6'],
          {
            color: C('Label/Light/Tertiary'),
            fontSize: scale(11),
            lineHeight: scale(16),
            position: 'absolute',
            right: -hourLength / 2 - 0.2,
            width: hourLength,
            height: scale(19),
            top: 0,
            textAlign: 'center',
          },
        ]}
      >
        {moment.format('HH')}:00
      </Text>
      <View style={{ height: scale(16) }} />
      <View
        style={{
          height: historyHeight / 4,
          borderRightWidth: 1,
          borderRightColor: C('Wallboard/Light/Tile Hairline'),
        }}
      />
    </View>
  );
};
